import React from "react";
import "./ui.scss";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "ghost";
  className?: string;
};

export const Button: React.FC<ButtonProps> = ({ variant = "primary", className = "", ...props }) => (
  <button {...props} className={`btn btn--${variant} ${className}`.trim()} />
);

export default Button;


